
// 区分是开发环境还是生产环境
// if (process.env.NODE_ENV === 'production') {
// openId = '';
// companyId = '';
//ipName = 'https://t.aohaisoft.com' // 废弃，毕竟url要变成自适应
// openId, companyId,
//     ipName = '';
// } else {
//     // openId = 'o9slduOkB2HbLQ_ZvkLHqoWVr5Ko'; // 开发时先写死
//     // companyId = 'aohyTest'; // 开发时先写死
//     openId = 'wx7aea50fda6f841e7'; // 开发时先写死
//     companyId = 'gzjdwl'; // 开发时先写死
//     //ipName = 'http://192.168.1.202:8090' // 有时t.aohaisoft.com会被重置而用不了，就换成这个
//     //ipName = 'https://t.aohaisoft.com'
//     ipName = '' // http://web.gnway.cc:' + (process.env.PORT || 8070)
// }

// apiParams存放接口几个共用的参数
export const apiParams = {
    companyId: '',
    openId: '',
    code: '',
    // ladingId: '',
    // servicetype: '',
};

// ipName是后台接口域名
let ipName = '';

export const apiUrl = {

    getAuthUrl: ipName + '/AohyWebchatS/getAuthUrl.do', // 微信授权登录
    menuPermission: ipName + '/AohyWebchatS/menuPermission.do', // 判断操作权限
    voyageSearch: ipName + '/AohyWebchatS/voyageSearch.do', // 获取船期查询所有起运港和目的港
    changePlace: ipName + '/AohyWebchatS/changePlace.do', // 起始地下拉框改变时，获取对应的目的地
    voyageTemplate: ipName + '/AohyWebchatS/voyageTemplate.do', // 获取船期查询的分页数据
    freightPrice: ipName + '/AohyWebchatS/freightPrice.do', // 获取报价查询的地点与shipper、group等数据
    freightPriceTemplate: ipName + '/AohyWebchatS/freightPriceTemplate.do', // 获取报价查询的分页数据
    businessTemplate: ipName + '/AohyWebchatS/businessTemplate.do', // 获取客户应用的business业务查询的分页数据
    shipperOrder: ipName + '/AohyWebchatS/shipperOrder.do', // 获取客户应用下单的多个下拉列表数据
    shipperAddOrder: ipName + '/AohyWebchatS/shipperAddOrder.do', // 增加客户应用的下单数据
    // 业务应用的接口
    voyageSearchYeWu: ipName + '/AohyWebchatS/voyageSearchYeWu.do', // 获取船期查询所有起运港和目的港
    changePort: ipName + '/AohyWebchatS/changePort.do', // 选择起始港后获取对应的目的港
    voyageTemplateYw: ipName + '/AohyWebchatS/voyageTemplateYw.do', // 获取船期查询的分页数据
    vehicleTemplate: ipName + '/AohyWebchatS/vehicleTemplate.do', // 获取调度应用的分页数据
    updateVehicle: ipName + '/AohyWebchatS/updateVehicle.do', // 更新调度应用的车辆状态数据
    quoteSearchCondition: ipName + '/AohyWebchatS/quoteSearchCondition.do', // 获取业务应用的报价查询的地址与柜量等数据
    quoteTemplate: ipName + '/AohyWebchatS/quoteTemplate.do', // 获取业务应用的报价查询的分页数据（即列表或表格数据）
    getConsignee: ipName + '/AohyWebchatS/getConsignee.do', // 下单--选择托运人-拉取他的货主
    getStartArea: ipName + '/AohyWebchatS/getStartArea.do', // 下单--选择托运人-拉取起始的地区（起运地）
    getShippersAndConts: ipName + '/AohyWebchatS/getShippersAndConts.do', // 获取业务应用托运人列表shippers与柜型柜量conts
    addOrder: ipName + '/AohyWebchatS/addOrder.do', // 获取业务应用托运人列表shippers与柜型柜量conts

    // 客户与业务应用共用的接口
    getKehuTel: ipName + '/AohyWebchatS/getKehuTel.do', // 获取“联系我们”的号码
    getArea: ipName + '/AohyWebchatS/getArea.do', // 选择托运人-货主--获取收货地区（目的地）
    getPlace: ipName + '/AohyWebchatS/getPlace.do', // 获取卸货地址，装货地址也是这个
    getLinkman: ipName + '/AohyWebchatS/getLinkman.do', // 获取装货/卸货联系人
    getOtherloadInfo: ipName + '/AohyWebchatS/getOtherloadInfo.do', // 获取装货/卸货联系人手机电话

    // 司机应用的接口
    todayPlan: ipName + '/AohyWebchatS/todayPlan.do', // 查询今日拖车计划
    tomorrowPlan: ipName + '/AohyWebchatS/tomorrowPlan.do', // 查询今日拖车计划
    reportNoSearch: ipName + '/AohyWebchatS/reportNoSearch.do', // 获取还没报柜号的计划，即ui图报柜号第一个页面
    getReportContNoSono: ipName + '/AohyWebchatS/getReportContNoSono.do', // 获取工作单下要报柜号的柜，一个工作单可能有多个柜号id，对应第二个页面
    reportContNo: ipName + '/AohyWebchatS/reportContNo.do', // 更新对应 的柜号、封号，对应第二个页面的报柜号/封号按钮，且一次只能更新一个柜号ID
    reportSealNoGet: ipName + '/AohyWebchatS/reportSealNoGet.do', // 只更新对应封号，暂时只用reportContNo接口去更新就好了，先不用这个接口
    //装货图片
    loadImgListController: ipName + '/AohyWebchatS/loadImgListController.do', // 获取《装货图片》，还未上传图片的列表数据
    loadImgLading: ipName + '/AohyWebchatS/loadImgLading.do', // 《装货图片》，获取是要上传还是查看的loadimgisupload（装箱）与sealimgisupload（封箱）
    loadImgUpload: ipName + '/AohyWebchatS/loadImgUpload.do', // 《装货图片》，上传装箱图片
    uploadSealController: ipName + '/AohyWebchatS/uploadSealController.do', // 《装货图片》，上传封箱图片
    loaddocUpload: ipName + '/AohyWebchatS/loaddocUpload.do', // 《装货图片》，上传装箱单证图片
    loadImgDisplay: ipName + '/AohyWebchatS/loadImgDisplay.do', // 《装货图片》，查看（获取）装箱图片
    lookSealImg: ipName + '/AohyWebchatS/lookSealImg.do', // 《装货图片》，查看（获取）封箱图片
    lookloaddoc: ipName + '/AohyWebchatS/lookloaddoc.do', // 《装货图片》，查看（获取）装箱单证图片
    //送货图片
    deliveImgListController: ipName + '/AohyWebchatS/deliveImgListController.do', // 获取《送货图片》，还未上传图片的列表数据
    deliveImgLading: ipName + '/AohyWebchatS/deliveImgLading.do', // 《送货图片》，获取是要上传还是查看的deliveimgisload（送货）与openimgisupload（开箱）
    uploadDelive: ipName + '/AohyWebchatS/uploadDelive.do', // 《送货图片》，上传送货图片(好像是送货的封箱图片另起名称为送货图片)
    uploadOpenController: ipName + '/AohyWebchatS/uploadOpenController.do', // 《送货图片》，上传开箱图片
    uploadDelivedoc: ipName + '/AohyWebchatS/uploadDelivedoc.do', // 《送货图片》，上传送货单证图片
    deliveImgDisplay: ipName + '/AohyWebchatS/deliveImgDisplay.do', // 《送货图片》，获取送货图片
    lookopenimg: ipName + '/AohyWebchatS/lookopenimg.do', // 《送货图片》，获取开箱图片
    lookDelivedoc: ipName + '/AohyWebchatS/lookdelivedoc.do', // 《送货图片》，查看（获取）送货单证图片

    feeMaintainPageList: ipName + '/AohyWebchatS/feeMaintainPageList.do', // 《费用维护》获取列表
    getFeeDetail: ipName + '/AohyWebchatS/getFeeDetail.do',// 《费用维护》，获取费用明细
    getFeeIdList: ipName + '/AohyWebchatS/getFeeIdList.do',// 《费用维护》， 获取司机可维护费用项目
    saveFee: ipName + '/AohyWebchatS/saveFee.do',// 《费用维护》，保存费用
    viewPicturesOrderList: ipName + '/AohyWebchatS/viewPicturesOrderList.do',// 《客户应用》，查看图片
    locationNoticeList: ipName + '/AohyWebchatS/locationNoticeList.do',// 《司机应用》 位置上传
    getLocationNoticeDetail: ipName + '/AohyWebchatS/getLocationNoticeDetail.do',// 《司机应用》位置上传详情
    locationNoticeSave: ipName + '/AohyWebchatS/locationNoticeSave.do',// 《司机应用》 位置上传
    getContainerDemurrageDaysList: ipName + '/AohyWebchatS/getContainerDemurrageDaysList.do', // 《客户应用》 滞期天数查询
    getAvailableMenu: ipName + '/AohyWebchatS/getAvailableMenu.do' // 获取首页菜单
};

export const homeMenu = {
    kehu: { // 客户菜单
        title: '客户应用',
        iconTitleUrl: require('@/assets/images/ic_yellow.png'),
        contentData: [{
            label: '船期查询',
            iconUrl: require('@/assets/images/wx_cqcx.png'),
            path: '/voyage-kehu',
            menuType: 'V1_VOYAGE',
        },
            {
                label: '报价查询',
                iconUrl: require('@/assets/images/wx_bjcx.png'),
                path: '/freight-price',
                menuType: 'V1_PRICE',
            },
            {
                label: '业务查询',
                iconUrl: require('@/assets/images/wx_bgh.png'),
                path: '/business',
                menuType: 'V1_BUSINESS',
            },
            {
                label: '客户下单',
                iconUrl: require('@/assets/images/wx_khxd.png'),
                path: '/shipper-order',
                menuType: 'V1_ORDER',
            },
            {
                label: '查看图片',
                iconUrl: require('@/assets/images/wx_tp_look.png'),
                path: '/view-picture-list',
                menuType: 'V1_ORDER',
            }
        ]
    },
    yewu: { // 业务菜单
        title: '业务员应用',
        iconTitleUrl: require('@/assets/images/ic_blue.png'),
        contentData: [{
            label: '船期查询',
            iconUrl: require('@/assets/images/wx_cqcx.png'),
            path: '/voyage-yewu',
            menuType: 'V2_VOYAGE',
        },
            {
                label: '调度应用',
                iconUrl: require('@/assets/images/wx_ddyy.png'),
                path: '/vehicletracking',
                menuType: 'V2_DIAODU',
            },
            {
                label: '报价查询',
                iconUrl: require('@/assets/images/wx_bjcx.png'),
                path: '/quote',
                menuType: 'V2_QUOTE',
            },
            {
                label: '业务下单',
                iconUrl: require('@/assets/images/wx_ywxd.png'),
                path: '/order',
                menuType: 'V2_ORDER',
            },
        ]
    },
    siji: { // 司机菜单
        title: '司机应用',
        iconTitleUrl: require('@/assets/images/ic_green.png'),
        contentData: [{
            label: '今日计划',
            iconUrl: require('@/assets/images/wx_jh_today.png'),
            path: '/today-plan',
            menuType: 'V3_PLAN',
        },
            {
                label: '明日计划',
                iconUrl: require('@/assets/images/wx_jh_tomorrow.png'),
                path: '/tomorrow-plan',
                menuType: 'V3_PLAN', // todo:今日与明日共用一个menuType可以吧？
            },
            {
                label: '报柜号',
                iconUrl: require('@/assets/images/wx_bgh.png'),
                path: '/report-no-list',
                menuType: 'V3_REPORT',
            },
            {
                label: '装货图片',
                iconUrl: require('@/assets/images/wx_tp_z.png'),
                path: '/load-img-list',
                menuType: 'V3_REPORT',
            },
            {
                label: '送货图片',
                iconUrl: require('@/assets/images/wx_tp_x.png'),
                path: '/delive-img-list',
                menuType: 'V3_DELIVERY',
            },
            {
                label: '费用维护',
                iconUrl: require('@/assets/images/wx_fy_weihu.png'),
                path: '/fee-maintain-list',
                menuType: 'V3_DELIVERY',
            },
            {
                label: '位置上传',
                iconUrl: require('@/assets/images/wx_wz_shangchuang.png'),
                path: '/location-upload-list',
                menuType: 'V3_DELIVERY',
            }
        ]
    }
};

export default {
    apiParams,
    apiUrl,
    homeMenu
}



// WEBPACK FOOTER //
// ./src/const/const.js